export enum ErrorTypes {
  emptyField = "emptyField",
  invalidvalue = "invalidvalue",
  largeFile = "largeFile",
}
